(() => {
  const container = document.getElementById('pdopage');
  if (!container) {
    return;
  }

  const listSelector = container.dataset.listSelector || '.production__list';
  const list = container.querySelector(listSelector);
  if (!list) {
    return;
  }

  const loadMoreButton = container.querySelector('[data-load-more]');
  const spinner = container.querySelector('[data-load-spinner]');
  const fallbackNav = container.querySelector('.pdopage__nav');

  if (!loadMoreButton) {
    return;
  }

  if (fallbackNav) {
    fallbackNav.style.display = 'none';
    fallbackNav.setAttribute('aria-hidden', 'true');
  }

  const totalPages = parseInt(container.dataset.totalPages || '1', 10) || 1;
  let currentPage = parseInt(container.dataset.page || '1', 10) || 1;
  let isLoading = false;

  const updateButtonState = () => {
    const hasMore = currentPage < totalPages;
    loadMoreButton.hidden = !hasMore;
    if (hasMore) {
      loadMoreButton.disabled = false;
      loadMoreButton.dataset.nextPage = String(currentPage + 1);
    }
  };

  const buildUrl = (page) => {
    const base = container.dataset.url || window.location.pathname;
    const url = new URL(base, window.location.origin);
    const currentQuery = new URL(window.location.href).searchParams;
    currentQuery.forEach((value, key) => {
      if (key.toLowerCase() === 'page') {
        return;
      }
      url.searchParams.append(key, value);
    });
    url.searchParams.set('page', page);
    return url.toString();
  };

  const appendItems = (html) => {
    if (!html) {
      return;
    }
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const fragment = document.createDocumentFragment();
    while (temp.firstChild) {
      fragment.appendChild(temp.firstChild);
    }
    list.appendChild(fragment);
  };

  const toggleSpinner = (visible) => {
    if (!spinner) {
      return;
    }
    spinner.hidden = !visible;
    spinner.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };

  const loadNextPage = (nextPage) => {
    if (isLoading) {
      return;
    }
    isLoading = true;
    loadMoreButton.disabled = true;
    toggleSpinner(true);

    fetch(buildUrl(nextPage), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network error');
        }
        return response.json();
      })
      .then((data) => {
        appendItems(data.itemsHtml || '');
        if (data && typeof data.page === 'number') {
          currentPage = data.page;
        } else {
          currentPage = nextPage;
        }
        if (data && data.hasMore === false) {
          loadMoreButton.hidden = true;
        }
      })
      .catch((error) => {
        console.error('Не удалось загрузить данные', error);
      })
      .finally(() => {
        isLoading = false;
        toggleSpinner(false);
        updateButtonState();
      });
  };

  loadMoreButton.addEventListener('click', () => {
    const nextPage = parseInt(loadMoreButton.dataset.nextPage || '0', 10);
    if (!nextPage || nextPage <= currentPage) {
      return;
    }
    loadNextPage(nextPage);
  });

  updateButtonState();
})();
